// import { ConfigOptions } from './config'
// export const Config = function (): ConfigOptions {
//     return {
//         mode: 'App',
//     }

// }

import { Connection, Session, Utility } from '@/utils'

// Define types for the expected values stored in the session storage
interface SessionData {
    ticket: string
    customer: any // Replace 'any' with the appropriate type for customer data
}

// Helper function to handle session data encoding/decoding
const encodeSessionData = (data: SessionData): string =>
    Utility.hexEncode(JSON.stringify(data))

const decodeSessionData = (encodedData: string): SessionData =>
    JSON.parse(Utility.hexDecode(encodedData))

// set global locale to current browser language
const Config = (): void => {
    //const root = 'https://localhost:7238/api'
    const root = import.meta.env.VITE_APP_API_QA
    //const root = import.meta.env.VITE_APP_URL

    Connection.config(
        {
            'login-code': `${root}/PatientAuth/send-login-code/`,
            'verify-login-code': `${root}/PatientAuth/verify-login-code/`,
            getQuestionnaire: `${root}/Questionnaire`,
            QuestionnaireAnswers: `${root}/QuestionnaireAnswers`,
            saveQuestionAnswer: `${root}/QuestionnaireAnswers/UpdateAnswer`,
            QuestionnaireResponse: `${root}/`,
            survey: `${root}/survey/`,
            WaitingList: `${root}/WaitingListRecord`,
            getPatient: `${root}/Patient`,
            informationPacks: `${root}/InformationPacks`,
            informationPackDetails: `${root}/InformationPacks`,
            waitingListRecords: `${root}/waitinglistrecords`,
            specialities: `${root}/specialities`,
            surgeons: `${root}/surgeons`,
            poaActions: `${root}/actions`,
            priorities: `${root}/priorities`,
            anaestheticTypes: `${root}/anaesthetic-types`,
            operationProcedures: `${root}/operation-procedures`,
            getQuestionnaireStatus: `${root}/waitinglistrecords`,
            intendedManagement: `${root}/IntendedManagement`,
            WaitingListRecord: `${root}/WaitingListRecord/{id}`,
            hospitals: `${root}/hospitals`,
        },
        {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json',
            'Access-Control-Allow-Origin': '*',
            'X-Tenant-Code': 'lot',
            Authorization: function () {
                return `Bearer ${Session.ticket()}`
            },

            //`Bearer ${Session.ticket()}`,
            //'x-session-ticket': (): string | null => Session.ticket(),
        },
        import.meta.env.app_qa_preop
    )

    Session.config(
        (ticket: any | null, customer: any): void => {
            if (!ticket || !customer) {
                window.sessionStorage.removeItem('ticket')
            } else {
                const sessionData: SessionData = {
                    ticket: ticket?.accessToken,
                    customer,
                }
                window.sessionStorage.setItem(
                    'ticket',
                    encodeSessionData(sessionData)
                )
            }
        },
        (): any => {
            const storedTicket = window.sessionStorage.getItem('ticket')
            if (storedTicket) {
                return decodeSessionData(storedTicket).customer
            }
            return null
        },
        (): string | null => {
            const storedTicket = window.sessionStorage.getItem('ticket')
            const userType = window.sessionStorage.getItem('userType')
            if (userType === 'poa') {
                const storedTicket = window.sessionStorage.getItem('ticket')
                if (storedTicket) {
                    const decodedTicket = decodeSessionData(storedTicket).ticket
                    return decodedTicket
                }
                return null
            }
            if (storedTicket) {
                return decodeSessionData(storedTicket).ticket
            }
            return null
        }
    )
}

const getAuth = () => {
    return import.meta.env.VITE_APP_QA_REDIRECT
}

const getClientId = () => {
    return import.meta.env.VITE_APP_CLIENT_ID_QA
}

const getAppClientId = () => {
    return import.meta.env.VITE_APP_API_APP_CLIENT_ID_QA
}

const getQuestionId = () => {
    return 1
}

export { getAppClientId, getAuth, getClientId, getQuestionId }
export default Config
